import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Container } from "reactstrap";

const Feedback = () => {
  const [text, setText] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();

    if (text && email) {
      toast.success("Feedback sent successfully!");
      setText("");
      setEmail("");
    } else {
      toast.error("Please fill out all fields.");
    }
  };

  const inputClass =
    "w-full rounded-xl border border-brand-forest/12 bg-white px-4 py-3 font-display text-[0.95rem] text-brand-forest outline-none transition placeholder:text-brand-muted/55 focus:border-brand-teal focus:ring-2 focus:ring-brand-teal/20";

  return (
    <main className="relative min-h-[calc(100vh-72px)] overflow-hidden bg-brand-surface">
      <div
        className="pointer-events-none absolute -left-24 top-10 h-72 w-72 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.18),transparent_70%)]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(10,43,30,0.08),transparent_72%)]"
        aria-hidden="true"
      />

      <section className="relative flex min-h-[calc(100vh-72px)] items-center py-12 md:py-16">
        <Container>
          <div className="mx-auto grid max-w-5xl items-center gap-8 lg:grid-cols-[1fr_1.1fr]">
            <div className="animate-fade-up max-lg:text-center">
              <p className="section-label">Feedback</p>
              <h1 className="mb-3 font-display text-[clamp(2rem,4vw,2.8rem)] font-extrabold tracking-tight text-brand-forest">
                Help us make studying clearer
              </h1>
              <p className="m-0 text-[1.05rem] leading-relaxed text-brand-muted">
                Tell us what worked, what felt stuck, or what you want next — we read every note.
              </p>
            </div>

            <form
              onSubmit={onSubmit}
              className="animate-fade-up-1 space-y-4 rounded-[22px] border border-brand-forest/10 bg-white p-6 shadow-brand sm:p-8"
            >
              <div className="flex flex-col gap-1.5">
                <label
                  htmlFor="feedback-email"
                  className="font-display text-sm font-semibold text-brand-forest"
                >
                  Email
                </label>
                <input
                  id="feedback-email"
                  type="email"
                  placeholder="you@email.com"
                  className={inputClass}
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label
                  htmlFor="feedback-text"
                  className="font-display text-sm font-semibold text-brand-forest"
                >
                  Your feedback
                </label>
                <textarea
                  id="feedback-text"
                  placeholder="What should we improve or add?"
                  rows={6}
                  className={`${inputClass} resize-y`}
                  value={text}
                  required
                  onChange={(e) => setText(e.target.value)}
                />
              </div>

              <button type="submit" className="btn w-full">
                Send feedback
              </button>
            </form>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Feedback;
